import styled from 'styled-components';

import { FontWeight, fontWeightMap } from '../../../fontWeight';

interface P2Props {
	'data-test-id'?: string;
	fontWeight?: FontWeight;
}

const P4 = styled.p<P2Props>`
	font-weight: ${({ fontWeight }: { fontWeight?: FontWeight }) => (fontWeight ? fontWeightMap : 'normal')};
	font-size: 0.8rem;
	line-height: 171%;
	margin: 0;
	font-style: normal;
	color: black;
`;

export default P4;
